// import React, { useState, useEffect } from "react";

// const Careerapplication = () => {
//   const [applications, setApplications] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [message, setMessage] = useState("");

//   useEffect(() => {
//     fetchApplications();
//   }, []);

//   const fetchApplications = async () => {
//     try {
//       const token = localStorage.getItem("access");
//       const response = await fetch(
//         "https://ambatturindustrialestate.com/api/api/applications/my-careers/",
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (response.ok) {
//         const data = await response.json();
//         setApplications(data);
//       } else {
//         setMessage("Failed to fetch applications.");
//       }
//     } catch (error) {
//       console.error("Error fetching applications:", error);
//       setMessage("An error occurred while fetching applications.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "long",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   if (loading) {
//     return (
//       <div className="container mt-4">
//         <div className="d-flex justify-content-center">
//           <div className="spinner-border" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="container mt-4">
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <h2>Career Applications</h2>
//         <button
//           className="btn btn-secondary"
//           onClick={() => window.history.back()}
//         >
//           Back
//         </button>
//       </div>

//       {message && (
//         <div
//           className={`alert ${
//             message.includes("successfully") ? "alert-success" : "alert-danger"
//           } alert-dismissible fade show`}
//         >
//           {message}
//           <button
//             type="button"
//             className="btn-close"
//             onClick={() => setMessage("")}
//           ></button>
//         </div>
//       )}

//       {applications.length === 0 ? (
//         <div className="card">
//           <div className="card-body text-center py-5">
//             <h5 className="card-title">No applications found</h5>
//             <p className="card-text">
//               No one has applied to your career postings yet.
//             </p>
//           </div>
//         </div>
//       ) : (
//         <div className="card">
//           <div className="card-header">
//             <h5 className="card-title mb-0">Applications Received</h5>
//           </div>
//           <div className="card-body">
//             <div className="table-responsive">
//               <table className="table table-hover">
//                 <thead>
//                   <tr>
//                     <th>Applicant Name</th>
//                     <th>Career Role</th>
//                     <th>Email</th>
//                     <th>Mobile</th>
//                     <th>Applied On</th>
//                     <th>Resume</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {applications.map((application) => (
//                     <tr key={application.id}>
//                       <td>{application.name}</td>
//                       <td>{application.career_role}</td>
//                       <td>
//                         <a href={`mailto:${application.email}`}>
//                           {application.email}
//                         </a>
//                       </td>
//                       <td>
//                         <a href={`tel:${application.mobile}`}>
//                           {application.mobile}
//                         </a>
//                       </td>
//                       <td>{formatDate(application.applied_at)}</td>
//                       <td>
//                         <a
//                           href={application.resume}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="btn btn-outline-primary btn-sm"
//                         >
//                           View Resume
//                         </a>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Careerapplication;
import React, { useState, useEffect } from "react";

const Careerapplication = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = async () => {
    try {
      const token = localStorage.getItem("access");
      const response = await fetch(
        "https://ambatturindustrialestate.com/api/api/applications/my-careers/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.ok) {
        const data = await response.json();
        // Filter only verified applications (is_verified: true)
        const verifiedApplications = data.filter(
          (app) => app.is_verified === true,
        );
        setApplications(verifiedApplications);
      } else {
        setMessage("Failed to fetch applications.");
      }
    } catch (error) {
      console.error("Error fetching applications:", error);
      setMessage("An error occurred while fetching applications.");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (loading) {
    return (
      <div className="container mt-4">
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Verified Career Applications</h2>
        <button
          className="btn btn-secondary"
          onClick={() => window.history.back()}
        >
          Back
        </button>
      </div>

      {message && (
        <div
          className={`alert ${
            message.includes("successfully") ? "alert-success" : "alert-danger"
          } alert-dismissible fade show`}
        >
          {message}
          <button
            type="button"
            className="btn-close"
            onClick={() => setMessage("")}
          ></button>
        </div>
      )}

      {applications.length === 0 ? (
        <div className="card">
          <div className="card-body text-center py-5">
            <h5 className="card-title">No verified applications found</h5>
            <p className="card-text">
              There are no verified applications to display at this time.
            </p>
          </div>
        </div>
      ) : (
        <div className="card">
          <div className="card-header">
            <h5 className="card-title mb-0">
              Verified Applications ({applications.length})
            </h5>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Applicant Name</th>
                    <th>Career Role</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>Applied On</th>
                    <th>Resume</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {applications.map((application) => (
                    <tr key={application.id}>
                      <td>{application.name}</td>
                      <td>{application.career_role}</td>
                      <td>
                        <a href={`mailto:${application.email}`}>
                          {application.email}
                        </a>
                      </td>
                      <td>
                        <a href={`tel:${application.mobile}`}>
                          {application.mobile}
                        </a>
                      </td>
                      <td>{formatDate(application.applied_at)}</td>
                      <td>
                        <a
                          href={application.resume}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-outline-primary btn-sm"
                        >
                          View Resume
                        </a>
                      </td>
                      <td>
                        <span className="badge bg-success">Verified</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Careerapplication;
